export const state = () => ({
  shipping: [],
  finalShippingPrice: null,
  isSameAsShippingSent: true,

  type: 'courier',
  paczkomat: null,
  paczkomatDetail: null,
})
